import { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "./api";
import { useAuth } from "./auth";

const FCtx = createContext(null);

export function FideicomisoProvider({ children }) {
    const { user } = useAuth();
    const [list, setList] = useState([]);
    const [selectedId, setSelectedId] = useState(() =>
        localStorage.getItem("trf_fid_id") || null,
    );
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (!user) return;
        setLoading(true);
        try {
            const { data } = await api.get("/fideicomisos");
            setList(data);
            if (!selectedId && data.length > 0) {
                setSelectedId(data[0].id);
                localStorage.setItem("trf_fid_id", data[0].id);
            }
        } finally {
            setLoading(false);
        }
    }, [user, selectedId]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    const select = useCallback((id) => {
        setSelectedId(id);
        localStorage.setItem("trf_fid_id", id);
    }, []);

    const selected = list.find((f) => f.id === selectedId) || null;

    return (
        <FCtx.Provider value={{ list, selected, selectedId, select, refresh, loading }}>
            {children}
        </FCtx.Provider>
    );
}

export function useFideicomiso() {
    const ctx = useContext(FCtx);
    if (!ctx) throw new Error("useFideicomiso must be used within FideicomisoProvider");
    return ctx;
}
